import React, { ReactNode } from 'react'

export const ChartCard: React.FC<{
  title: string
  value?: string
  children: ReactNode
  filter?: ReactNode
}> = ({ title, value = '', children, filter }) => {
  return (
    <div
      className="
      p-6
      rounded-xl
      border border-divider-gray
        "
    >
      <div className="flex mb-3 items-center justify-between gap-4 flex-wrap">
        <p className="text-lg font-medium">{title}</p>

        {filter ? filter : undefined}
      </div>

      {value && (
        <span
          className="
          font-medium text-xl
          block mb-4
        "
        >
          {value}
        </span>
      )}
      {children}
    </div>
  )
}
